/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { TypeMoney } from '../models/TypeMoney';
import { HttpFile } from '../http/http';

/**
* The range of costs that the order line could result in
*/
export class V1CostRange {
    'estimate'?: TypeMoney;
    'min'?: TypeMoney;
    'max'?: TypeMoney;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "estimate",
            "baseName": "estimate",
            "type": "TypeMoney",
            "format": ""
        },
        {
            "name": "min",
            "baseName": "min",
            "type": "TypeMoney",
            "format": ""
        },
        {
            "name": "max",
            "baseName": "max",
            "type": "TypeMoney",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1CostRange.attributeTypeMap;
    }

    public constructor() {
    }
}

